"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlockPolledLiquityStore = void 0;
const lib_base_1 = require("@liquity/lib-base");
const _utils_1 = require("./_utils");
const EthersLiquityConnection_1 = require("./EthersLiquityConnection");
/**
 * Ethers-based {@link @liquity/lib-base#LiquityStore} that updates state whenever there's a new
 * block.
 *
 * @public
 */
class BlockPolledLiquityStore extends lib_base_1.LiquityStore {
    constructor(readable) {
        super();
        this.connection = readable.connection;
        this._readable = readable;
        this._provider = EthersLiquityConnection_1._getProvider(readable.connection);
    }
    async _getYetiControllerData() {
        const url = "https://api.yeti.finance/v1/yeticontroller";
        try {
            const response = await fetch(url, {
                method: "GET", mode: 'cors'
            });
            const rawResult = await response.json();
            if (Object.entries(rawResult).every(([k, v]) => ["_id", "blockNum", "timestamp"].includes(k) || v.value)) {
                console.log(rawResult);
                const result = {
                    whitelistedCollaterals: rawResult.whitelistedCollaterals,
                    vaultTokens: { value: rawResult.vaultTokens.value.filter(address => address !== "0x0000000000000000000000000000000000000000") },
                    underlyingTokens: { value: rawResult.underlyingTokens.value.filter(address => address !== "0x0000000000000000000000000000000000000000") },
                    underlyingDecimals: { value: {} },
                    underlyingPerReceptRatios: { value: {} },
                    receiptPerUnderlyingRatios: { value: {} },
                    prices: { value: {} },
                    underlyingPrices: { value: {} }
                };
                Object.keys(rawResult.underlyingDecimals.value).map(address => {
                    result.underlyingDecimals.value[address] = lib_base_1.Decimal.fromWithPrecision(rawResult.underlyingDecimals.value[address], 0);
                });
                Object.keys(rawResult.underlyingPerReceptRatios.value).map(address => {
                    result.underlyingPerReceptRatios.value[address] = lib_base_1.Decimal.fromWithPrecision(rawResult.underlyingPerReceptRatios.value[address], 0);
                });
                Object.keys(rawResult.receiptPerUnderlyingRatios.value).map(address => {
                    result.receiptPerUnderlyingRatios.value[address] = lib_base_1.Decimal.fromWithPrecision(rawResult.receiptPerUnderlyingRatios.value[address], 0);
                });
                Object.keys(rawResult.prices.value).map(address => {
                    result.prices.value[address] = lib_base_1.Decimal.fromWithPrecision(rawResult.prices.value[address], 0);
                });
                Object.keys(rawResult.underlyingPrices.value).map(address => {
                    result.underlyingPrices.value[address] = lib_base_1.Decimal.fromWithPrecision(rawResult.underlyingPrices.value[address], 0);
                });
                return result;
            }
            else {
                return null;
            }
        }
        catch (error) {
            console.log("error", error);
            return null;
        }
    }
    async _get(blockTag) {
        const equals = (a, b) => a.length === b.length &&
            a.every((v, i) => v === b[i]);
        const equalsTM = (a, b) => Object.keys(a).length + 2 === Object.keys(b).length &&
            Object.keys(a).every((v) => a[v].eq(b[v]));
        const { userAddress } = this.connection;
        // const userAddress = "0x3fCaCb1F0063eF740F2fcd48D9De6c74078d2ea7"
        const yetiControllerData = await this._getYetiControllerData();
        // console.log(yetiControllerData)
        let whitelistedCollaterals, vaultTokens, underlyingTokens;
        let underlyingDecimals, underlyingPerReceiptRatios, receiptPerUnderlyingRatios, prices, underlyingPrices;
        if (yetiControllerData) {
            whitelistedCollaterals = yetiControllerData.whitelistedCollaterals.value;
            vaultTokens = yetiControllerData.vaultTokens.value;
            underlyingTokens = yetiControllerData.underlyingTokens.value;
            underlyingDecimals = yetiControllerData.underlyingDecimals.value;
            underlyingPerReceiptRatios = yetiControllerData.underlyingPerReceptRatios.value;
            receiptPerUnderlyingRatios = yetiControllerData.receiptPerUnderlyingRatios.value;
            prices = yetiControllerData.prices.value;
            underlyingPrices = yetiControllerData.underlyingPrices.value;
        }
        else {
            whitelistedCollaterals = await this._readable.getWhitelistedCollaterals({ blockTag });
            vaultTokens = await this._readable.getVaultTokens(whitelistedCollaterals, { blockTag });
            underlyingTokens = await this._readable.getUnderlyingTokens(vaultTokens);
            underlyingDecimals = await this._readable.getUnderlyingDecimals(vaultTokens);
            const { underlyingPerReceiptRatios_, receiptPerUnderlyingRatios_, prices_, underlyingPrices_ } = await _utils_1.promiseAllValues({
                underlyingPerReceiptRatios_: this._readable.getUnderlyingPerReceiptRatios(whitelistedCollaterals, vaultTokens),
                receiptPerUnderlyingRatios_: this._readable.getReceiptPerUnderlyingRatios(whitelistedCollaterals, vaultTokens),
                prices_: this._readable.getPrices(whitelistedCollaterals),
                underlyingPrices_: this._readable.getCollPrices(whitelistedCollaterals, vaultTokens, underlyingDecimals, { blockTag })
            });
            underlyingPerReceiptRatios = underlyingPerReceiptRatios_;
            receiptPerUnderlyingRatios = receiptPerUnderlyingRatios_;
            prices = prices_;
            underlyingPrices = underlyingPrices_;
        }
        // const whitelistedCollaterals1 = await this._readable.getWhitelistedCollaterals({ blockTag })
        // const vaultTokens1 = await this._readable.getVaultTokens(whitelistedCollaterals, { blockTag })
        // const underlyingTokens1 = await this._readable.getUnderlyingTokens(vaultTokens)
        // console.log("whitelistedCollaterals Check ", equals(whitelistedCollaterals, whitelistedCollaterals1))
        // console.log("vaultTokens Check", equals(vaultTokens, vaultTokens1))
        // console.log("underlyingTokens Check", equals(underlyingTokens, underlyingTokens1))
        const tokenBalancesUnderlyingAndWhitelisted = whitelistedCollaterals.concat(underlyingTokens);
        // const underlyingDecimals = yetiControllerData ? yetiControllerData?.underlyingDecimals.value : await this._readable.getUnderlyingDecimals(vaultTokens)
        // const underlyingDecimals1 = await this._readable.getUnderlyingDecimals(vaultTokens)
        // console.log("underlyingDecimals Check", equalsTM(underlyingDecimals1, underlyingDecimals))
        // console.log(underlyingDecimals1, underlyingDecimals)
        // const tokenBalancesUnderlyingAndWhitelisted:string[] = whitelistedCollaterals
        const { blockTimestamp } = await _utils_1.promiseAllValues({ blockTimestamp: this._readable._getBlockTimestamp(blockTag) });
        // const underlyingPerReceiptRatios = yetiControllerData ? yetiControllerData?.underlyingPerReceptRatios.value : underlyingPerReceiptRatios1
        // console.log("underlyingPerReceiptRatios Check", equalsTM(underlyingPerReceiptRatios1, underlyingPerReceiptRatios))
        // const receiptPerUnderlyingRatios = yetiControllerData ? yetiControllerData?.receiptPerUnderlyingRatios.value : receiptPerUnderlyingRatios1
        // console.log("receiptPerUnderlyingRatios Check", equalsTM(receiptPerUnderlyingRatios1, receiptPerUnderlyingRatios))
        // const prices = yetiControllerData ? yetiControllerData?.prices.value : prices1
        // console.log("prices Check", equalsTM(prices1, prices))
        // const underlyingPrices = yetiControllerData ? yetiControllerData?.underlyingPrices.value : underlyingPrices1
        // console.log("underlyingPrices Check", equalsTM(underlyingPrices1, underlyingPrices))
        const { _feesFactory, numberOfTroves, poolRewardRate, yusdInStabilityPool, remainingStabilityPoolYETIReward, totalRedistributed, total, accountBalance, yusdBalance, yetiBalance, stabilityDeposit, farm, boostedFarm, veYETIStaked, collateralSurplusBalance, troveBeforeRedistribution, tokenBalances, lpTokenBalance, icr, vcValue, recoveryRatios, safetyRatios, decimals, YETIPrice, YUSDPrice, globalBoostFactor, decayedBoost } = await _utils_1.promiseAllValues({
            _feesFactory: this._readable._getFeesFactory({ blockTag }),
            numberOfTroves: this._readable.getNumberOfTroves({ blockTag }),
            poolRewardRate: this._readable.getPoolRewardRate({ blockTag }),
            yusdInStabilityPool: this._readable.getYUSDInStabilityPool({ blockTag }),
            remainingStabilityPoolYETIReward: this._readable.getRemainingStabilityPoolYETIReward({
                blockTag
            }),
            totalRedistributed: this._readable.getTotalRedistributed({ blockTag }),
            total: this._readable.getTotal({ blockTag }),
            accountBalance: this._provider.getBalance(userAddress !== null && userAddress !== void 0 ? userAddress : '0', blockTag).then(_utils_1.decimalify),
            yusdBalance: this._readable.getYUSDBalance(userAddress, { blockTag }),
            yetiBalance: this._readable.getYETIBalance(userAddress, { blockTag }),
            stabilityDeposit: this._readable.getStabilityDeposit(userAddress, { blockTag }),
            farm: this._readable.getFarm(userAddress, { blockTag }),
            boostedFarm: this._readable.getBoostedFarm(userAddress, { blockTag }),
            veYETIStaked: this._readable.getVEYETIStake(userAddress, { blockTag }),
            collateralSurplusBalance: this._readable.getCollateralSurplusBalancee({ blockTag }),
            troveBeforeRedistribution: this._readable.getTroveBeforeRedistribution(userAddress, {
                blockTag
            }),
            tokenBalances: this._readable.getBalances(tokenBalancesUnderlyingAndWhitelisted),
            lpTokenBalance: this._readable.getLPBalances(userAddress, { blockTag }),
            icr: this._readable.getICR(userAddress, { blockTag }),
            vcValue: this._readable.getVcValue(userAddress, { blockTag }),
            safetyRatios: this._readable.getSafetyRatios(whitelistedCollaterals),
            recoveryRatios: this._readable.getRecoveryRatios(whitelistedCollaterals),
            decimals: this._readable.getDecimals(whitelistedCollaterals),
            YETIPrice: this._readable.getYETIPrice(),
            YUSDPrice: this._readable.getYUSDPrice(),
            globalBoostFactor: this._readable.getGlobalBoostFactor(),
            decayedBoost: this._readable.getDecayedBoost(userAddress),
        });
        return [
            {
                numberOfTroves,
                underlyingPrices,
                totalRedistributed,
                total,
                poolRewardRate,
                yusdInStabilityPool,
                remainingStabilityPoolYETIReward,
                accountBalance,
                tokenBalances,
                lpTokenBalance,
                yusdBalance,
                yetiBalance,
                collateralSurplusBalance,
                troveBeforeRedistribution,
                stabilityDeposit,
                farm,
                boostedFarm,
                veYETIStaked,
                _feesInNormalMode: _feesFactory(blockTimestamp, false),
                whitelistedCollaterals,
                icr,
                vcValue,
                safetyRatios,
                recoveryRatios,
                decimals,
                YETIPrice,
                YUSDPrice,
                globalBoostFactor,
                decayedBoost,
                prices,
                vaultTokens,
                receiptPerUnderlyingRatios,
                underlyingPerReceiptRatios,
                underlyingDecimals,
                underlyingTokens
            },
            {
                blockTag,
                blockTimestamp,
                _feesFactory
            }
        ];
    }
    /** @internal @override */
    _doStart() {
        // console.log('_loaded', this._loaded)
        // console.log('_load', this._load)
        // this._get().then(state => {
        //   if (!this._loaded) {
        //     this._load(...state);
        //   }
        // });
        const blockListener = async (blockTag) => {
            const state = await this._get(blockTag);
            if (this._loaded) {
                this._update(...state);
            }
            else {
                this._load(...state);
            }
        };
        this._provider.on("block", blockListener);
        return () => {
            this._provider.off("block", blockListener);
        };
    }
    /** @internal @override */
    _reduceExtra(oldState, stateUpdate) {
        var _a, _b, _c;
        return {
            blockTag: (_a = stateUpdate.blockTag) !== null && _a !== void 0 ? _a : oldState.blockTag,
            blockTimestamp: (_b = stateUpdate.blockTimestamp) !== null && _b !== void 0 ? _b : oldState.blockTimestamp,
            _feesFactory: (_c = stateUpdate._feesFactory) !== null && _c !== void 0 ? _c : oldState._feesFactory
        };
    }
}
exports.BlockPolledLiquityStore = BlockPolledLiquityStore;
//# sourceMappingURL=BlockPolledLiquityStore.js.map